var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5608 2.86976C19.1337 3.99406 19.1337 5.46584 19.1337 8.40941V11.2463C19.1337 11.5403 19.1337 11.6873 19.1278 11.8114C18.9997 14.5188 16.8337 16.6848 14.1263 16.8129C14.0022 16.8188 13.8382 16.8188 13.5103 16.8188L13.4261 16.8189C12.3537 16.8257 11.3089 17.1605 10.4323 17.7783L10.3766 17.8181L7.63223 19.7783C6.69144 20.4502 5.45519 19.4798 5.88456 18.4064C6.18872 17.646 5.62872 16.8188 4.80975 16.8188H4.1772C1.98757 16.8188 0.212524 15.0438 0.212524 12.8541V8.40941C0.212524 5.46584 0.212524 3.99406 0.78538 2.86976C1.28928 1.88081 2.09333 1.07675 3.08229 0.572856C4.20658 0 5.67836 0 8.62193 0H10.7243C13.6679 0 15.1396 0 16.264 0.572856C17.2529 1.07675 18.057 1.88081 18.5608 2.86976ZM6.51958 8.40941C6.51958 8.98995 6.04895 9.46058 5.4684 9.46058C4.88786 9.46058 4.41723 8.98995 4.41723 8.40941C4.41723 7.82886 4.88786 7.35823 5.4684 7.35823C6.04895 7.35823 6.51958 7.82886 6.51958 8.40941ZM10.7243 8.40941C10.7243 8.98995 10.2536 9.46058 9.67311 9.46058C9.09256 9.46058 8.62193 8.98995 8.62193 8.40941C8.62193 7.82886 9.09256 7.35823 9.67311 7.35823C10.2536 7.35823 10.7243 7.82886 10.7243 8.40941ZM13.8778 9.46058C14.4584 9.46058 14.929 8.98995 14.929 8.40941C14.929 7.82886 14.4584 7.35823 13.8778 7.35823C13.2972 7.35823 12.8266 7.82886 12.8266 8.40941C12.8266 8.98995 13.2972 9.46058 13.8778 9.46058Z",
    fill: "#8A92A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.85a570bc9cabf02b4fc027fa192f77f7.svg";
export { ForwardRef as ReactComponent };